import React, { Suspense, useEffect } from 'react';
import Router from './core/routes';
import { RouterProvider } from 'react-router-dom';
import './index.css';
import 'swiper/swiper-bundle.css';
import InitApm from './core/apm';
import { Toast } from './core/components/atoms/Toast';
import { useUserStore } from './modules/Auth/stores/authStore';
import { setTheme } from './core/utils';
import GTM from './core/track/gtm';
import { loadWootric } from './core/track/wootric';
import { AuthRoutes } from './modules/Auth/routes';
import { loadScriptKira } from './core/track/kira';

export default function App() {
  const { user } = useUserStore();

  function updateUserTheme() {
    if (window.location.pathname.includes('/simuladao')) {
      setTheme('light');
      return;
    }

    setTheme(user && user.isDarkMode ? 'dark' : 'light');
  }

  useEffect(() => {
    InitApm();
    GTM();

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (params.has('token')) {
      const token = params.get('token');
      if (token) {
        localStorage.setItem('bt:accessToken', token);
      }
    }
  }, []);

  useEffect(() => {
    if (user && user.email) {
      loadWootric(user);
    }
  }, [user]);

  useEffect(() => {
    console.log("Script useEffect Kira");
    if (user && window) {
      console.log("Loading Kira script for user");
      loadScriptKira(user);
    }
    return () => {};
  }, [user, window]);

  useEffect(() => {
    updateUserTheme();
  }, [user?.isDarkMode]);

  useEffect(() => {
    const authPaths = AuthRoutes.map((route) => route.path.split('/')[0]);

    const isInAuth = authPaths.some((path) =>
      window.location.pathname.includes(path)
    );

    if (!isInAuth) {
      localStorage.setItem('lastPath', window.location.pathname);
    }

    updateUserTheme();
  }, [window.location.pathname]);

  return (
    <Suspense fallback={<></>}>
      <Toast />
      <RouterProvider router={Router} fallbackElement={<p>Carregando</p>} />
    </Suspense>
  );
}
